import 'react-toastify/dist/ReactToastify.css';
import 'react-tabs/style/react-tabs.css';
import 'themes/styles/app.css';
import React from 'react';
import Modal from 'react-modal';
import { createRoot } from 'react-dom/client';
import { Provider } from 'mobx-react';
import { I18nextProvider } from 'react-i18next';
import { localizationService } from 'core/services';
import { App } from 'core/components';
import { bootstrap, platform } from 'common/infrastructure';
import { RootStore } from 'common/stores';
import { walmartHandoff } from 'common/utils';

function startApplication() {
	// Has to run before the router does: Walmart appends its connect parameters to whichever URL is
	// registered as our App Login URL, and the first transition throws the query string away.
	walmartHandoff.capture();

	const context = {
		rootStore: new RootStore(platform),
	};
	const container = document.getElementById('root');
	const root = createRoot(container);
	bootstrap.run(context);
	renderApp(context, root);
}

function renderApp({ rootStore }, root) {
	Modal.setAppElement('#root');
	root.render(
		<I18nextProvider i18n={localizationService}>
			<Provider rootStore={rootStore}>
				<App />
			</Provider>
		</I18nextProvider>
	);
}

startApplication();
